module.exports = __webpack_public_path__ + "img/schermata.d1849539.png";